import appConfig from "appConfig";

export const GITHUB_OAUTH_URL = `http://github.com/login/oauth/authorize?client_id=${appConfig.github_client_id}`;
export const callbackUrl = `${appConfig.api_base_url}/auth/github/callback`;
